// src/components/operationCenter/widgets/token/derivatives/TwWeightedFundingChartWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import WeightedFundingChartCard from "@/components/tokenPage/derivatives/WeightedFundingChartCard";

const TwWeightedFundingChartWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["derivatives"]}>
        <WeightedFundingChartCard ticker={config.ticker.toUpperCase()} />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwWeightedFundingChartWidget;
